import { makeStyles } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../layout'
import { useData } from '../../../../data'
import { Form } from 'antd'
import { CTAButton } from '../../components'
import { trackPromise, usePromiseTracker } from 'react-promise-tracker'

const useStyles = makeStyles(theme => ({
    topBar: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        [theme.breakpoints.up('lg')]: {
            width: '30%'
        }
    },
    title: {
        fontSize: 24,
        fontWeight: 'bold',
        fontStyle: 'normal'
    },
    content: {
        marginTop: theme.spacing(2),
        display: 'flex',
        width: '100%',
        height: '100%',
        padding: '10px',
        flexDirection: 'column'
    },
    error: {
        fontSize: 18,
        color: 'red'
    },
    success: {
        fontSize: 18,
        color: 'green'
    },
    form: {
        maxWidth: '600px'
    }
}))

/**
 * Tools dashboard view page
 */
const FullBuildPage = (props) => {
    const classes = useStyles()
    const [form] = Form.useForm()
    const [error, setError] = useState(null)
    const [status, setStatus] = useState({ currentBuildStatus: "", lastBuildStatus: "" })

    const { promiseInProgress } = usePromiseTracker()
    const data = useData()
    const uemail = data.uemail()

    // load the current status
    const loadStatus = () => {
        trackPromise(
            uemail.getCurrentStatus()
                .then(res => {
                    setStatus({
                        currentBuildStatus: res.current_build_status,
                        lastBuildStatus: res.last_build_status
                    })
                    setError(null)
                })
                .catch(err => setError(err.message))

        )
    }

    useEffect(() => {
        loadStatus()
    }, [])
    useEffect(() => {
        const intervalId = setInterval(() => {
            loadStatus()
            // remove es-lint warning
        }, 10000)
        return () => clearInterval(intervalId);
    }, [])

    const { currentBuildStatus, lastBuildStatus } = status;

    const fullBuild = (vals) => {
        setError(null)

        // process the parametes 
        const { parameters = [] } = vals
        const params = {}

        for (let param of parameters) {
            const { param_key, param_value } = param

            params[param_key] = param_value
        }

        trackPromise(
            uemail.fullBuild({ ...vals, parameters: params })
                .then(res => {
                    setStatus({
                        currentBuildStatus: res.current_build_status,
                        lastBuildStatus: res.last_build_status
                    })
                    setError(null)
                })
                .catch(err => setError(err.message))
        )
    }

    return (
        <DashboardLayout
            selected="email_universe"
        >
            <div className={classes.content}>
                <p className={classes.title}>Perform Full Build</p>
                <br />
                <p>
                    Perform full build. Note that it takes a bit of time to run this.
                    The response will be immediately returned and you can refresh this page
                    to see the stautus of alaready build submitted.
                </p>
                <Form
                    layout="horizontal"
                    onFinish={fullBuild}
                    form={form}
                    className={classes.form}

                >
                    <p>Current build status: {currentBuildStatus}</p>
                    <p>Last build status: {lastBuildStatus}</p>
                    <Form.Item >
                        <CTAButton type="submit" loading={promiseInProgress}>Perform Full Build</CTAButton>
                    </Form.Item>
                    {
                        error && (
                            <Form.Item >
                                <p className={classes.error}>An error occurred.</p>
                            </Form.Item>
                        )
                    }
                </Form>
            </div>
        </DashboardLayout>
    )
}

export default FullBuildPage
